<!-- modal wrap -->
<div class="fade modal-backdrop modal-backdrop--route show"></div>
<div class="d-block fade main-modal modal show modal--route">
    <div class="close-modal-area" (click)="dismiss()"></div>
    <div class="modal-dialog">
        <div class="modal-content">
            
            <span class="close-modal-outside"><i (click)="dismiss()" class="im-icon im-icon-x-light"></i></span>
            <div class="modal-wrap">
                <div class="d-flex">
                    <div class="d-flex flex-column w-100 flex-grow-1 scroll-y-- position-relative">                

                        @let apiKeyCreated = apiKey.length ? true : false;
                        
                        @if (apiKeyCreated) {
                            <div class="detail-modal-body detail-modal-body--form">
                                <div class="api-key-wrap">
                                    <div class="d-flex flex-column flex-grow-1 justify-content-between gap-2">
                                        <div class="d-flex align-items-center mb-xs">
                                            <i class="im-icon im-icon-key mr-xs" style="font-size: 32px;"></i>
                                            <h2 class="mb-0">API key aangemaakt</h2>
                                        </div>
                                        <div class="mb-xs d-flex flex-column gap-2">
                                            <p>Om veiligheidsredenen kunnen we de key niet opnieuw tonen.</p>
                                            <p>Kopieer de API key en bewaar hem ergens veilig.</p>
                                        </div>
                                        <div class="copy-key">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span class="key">{{apiKey}}</span>
                                                <div>
                                                    <button (click)="copyToClipboard()" class="button default">
                                                        <i class="im-icon im-icon-clipboard"></i>
                                                        <span>Kopiëren</span>
                                                    </button>
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <!-- MODAL HEAD -->
                            <div class="detail-modal-header d-flex flex-row justify-content-between align-items-center" >
                                <h1 class="d-flex align-items-center">API key toevoegen</h1>
                            </div>
                            <!-- MODAL BODY -->
                            <div class="detail-modal-body detail-modal-body--form" >
                                <app-field-text [class.saving]="submitting"
                                    [model]="FORM" 
                                    (modelChange)="FORM = $event; formChange();" 
                                    [label]="'Klant'"
                                    [ignorePassword]="true"
                                    [error]="validation?.klant"
                                ></app-field-text>
                            </div>
                            
                            <div class="detail-modal-footer d-flex flex-row">
                                <div class="h-100 d-flex align-items-center buttons-wrap" [class.button--submitting]="submitting">
                                    <button (click)="generateApiKey()" class="button-component primary-default gap-2">
                                        @if (submitting) { <app-inline-spinner [light]="true" /> }
                                        @else {<i class="im-icon im-icon-plus-round"></i> }
                                        <span>API key genereren</span>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>